module.exports = __webpack_public_path__ + "img/地址设置例子.b76234e5.png";